module.exports = __webpack_public_path__ + "static/img/hiturn-ewm.8b25925.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hiturn-ewm.jpg
// module id = fabO
// module chunks = 90